var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _vm.tasks && _vm.tasks.length
      ? _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-sm table-hover" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.tasks, function (task, i) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(i + 1))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(task.object_id) + "\n              "),
                      _c("i", {
                        staticClass: "icon-fa icon-fa-edit openEditDrugIcon",
                        on: {
                          click: function ($event) {
                            return _vm.openDrugEdit(task.object_id)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(task.drug?.title))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "(" +
                          _vm._s(task.task_data.new_code.id) +
                          ") " +
                          _vm._s(task.task_data.new_code.title) +
                          "\n"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      _vm._l(
                        _vm.getDetailGroup(task?.drug?.details ?? []),
                        function (code) {
                          return _c("div", { staticClass: "flex" }, [
                            _c("div", { staticClass: "pr-2 flex-grow-1" }, [
                              _c("p", [
                                _vm._v(
                                  "(" +
                                    _vm._s(code.id) +
                                    ") " +
                                    _vm._s(code.title)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                task.task_data.detail_id == code.detail_id
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-content-between",
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c("LoadingButton", {
                                                attrs: {
                                                  title:
                                                    '<i class="icon-fa icon-fa-save"/>',
                                                  loading:
                                                    _vm.loadingTaskBtns[
                                                      task.id
                                                    ],
                                                  onClick: () =>
                                                    _vm.updateTask(task.id),
                                                  color:
                                                    _vm.$constants
                                                      .SUCCESS_COLOR,
                                                  className:
                                                    "btn btn-outline-success",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ])
                        }
                      ),
                      0
                    ),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _vm.paginator
            ? _c("div", [
                _c("p", [
                  _vm._v("всего кодов: "),
                  _c("strong", [_vm._v(_vm._s(_vm.paginator.total))]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _vm.records
            ? _c("table", { staticClass: "table table-sm table-hover" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.records, function (drug, i) {
                    return _c("tr", [
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            i +
                              1 +
                              (_vm.paginator.current_page - 1) *
                                _vm.paginator.per_page
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(drug.id))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(drug.title))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(drug.details, function (detail) {
                          return _vm.codes[detail.int_value]
                            ? _c("div", { staticClass: "flex" }, [
                                _c("div", { staticClass: "pr-2" }, [
                                  _c("p", [
                                    _vm._v("Код: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.codes[detail.int_value].id)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Дата деактивации:\n                    "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.printDate(
                                            _vm.codes[detail.int_value]
                                              .invalid_date,
                                            "DD.MM.YYYY"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm.codes[detail.int_value].valid_id &&
                                  +_vm.codes[detail.int_value].valid_id !== -1
                                    ? _c("p", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [
                                            _vm._v("Замена "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.codes[detail.int_value]
                                                    .valid_id
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-grow flex-grow-1" },
                                  [
                                    _c("EgkSelect", {
                                      ref: "egkCodes",
                                      refInFor: true,
                                      attrs: {
                                        hideDetails: true,
                                        updateDetail: (d) =>
                                          _vm.addNewCode(detail, d),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "accept_block" },
                                  [
                                    _vm.newCodes[detail.id]
                                      ? [
                                          _c("LoadingButton", {
                                            attrs: {
                                              title:
                                                '<i class="icon-fa icon-fa-save"/>',
                                              loading:
                                                _vm.loadingBtns[detail.id],
                                              onClick: () =>
                                                _vm.saveCode(detail.id),
                                              color:
                                                _vm.$constants.SUCCESS_COLOR,
                                              className:
                                                "btn btn-outline-success",
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e()
                        }),
                        0
                      ),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.paginator
                ? _c("paginate", {
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 5,
                      "margin-pages": 2,
                      "click-handler": _vm.getDrugs,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.paginator.current_page,
                      callback: function ($$v) {
                        _vm.$set(_vm.paginator, "current_page", $$v)
                      },
                      expression: "paginator.current_page",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("ЕГК коды на модерации")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("ЕГК")]),
        _vm._v(" "),
        _c("th", [_vm._v("Новый ЕГК")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("ЕГК")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }